<template>
  <div v-show="canShow" class="c_loading">
    <div id="#preloader_1" class="c_loading-load">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',

  props: {
    canShow: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c_loading {
  z-index: 10001;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  & > div {
    margin-top: -3.33333rem;
  }
  &-load {
    width: 8.33333rem;
  }
}

.c_loading-load {
  position: relative;
  margin-left: 4.16rem;
  display: flex;
  align-items: center;
}
.c_loading-load > span {
  width: 0.6rem;
  height: 0.333rem;
  background: #9b59b6;
  animation: preloader_1 1.5s infinite ease-in-out;
  margin-left: 0.15rem;
}

.c_loading-load > span:nth-child(2) {
  left: 0.7333rem;
  animation-delay: 0.2s;
}

.c_loading-load > span:nth-child(3) {
  left: 1.4667rem;
  animation-delay: 0.4s;
}

.c_loading-load > span:nth-child(4) {
  left: 2.2rem;
  animation-delay: 0.6s;
}

.c_loading-load > span:nth-child(5) {
  left: 2.933rem;
  animation-delay: 0.8s;
}

@keyframes preloader_1 {
  0% {
    height: 0.333rem;
    transform: translateY(0);
    background: #9b59b6;
  }

  25% {
    height: 2.1rem;
    transform: translateY(p2r(30));
    background: #3498db;
  }

  50% {
    height: 0.333rem;
    transform: translateY(0);
    background: #9b59b6;
  }

  100% {
    height: 0.333rem;
    transform: translateY(0);
    background: #9b59b6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toggleloading/toggleloading.vue